import { render, staticRenderFns } from "./TeamSingle.vue?vue&type=template&id=c5182238&scoped=true&"
import script from "./TeamSingle.vue?vue&type=script&lang=js&"
export * from "./TeamSingle.vue?vue&type=script&lang=js&"
import style0 from "./TeamSingle.vue?vue&type=style&index=0&id=c5182238&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5182238",
  null
  
)

component.options.__file = "TeamSingle.vue"
export default component.exports